import { ILog } from "@ihr-radioedit/inferno-core";

const log = ILog.logger("recurly");

const loadJSLib = () => {
  if (typeof window === "undefined") {
    return Promise.reject();
  }

  if (typeof window.recurly === "undefined") {
    return new Promise((resolve, reject) => {
      log.debug(`Injecting script.`);

      const script = document.createElement("script");
      script.src = "https://js.recurly.com/v4/recurly.js";
      script.type = "text/javascript";
      script.defer = true;
      script.async = true;
      script.onload = () => {
        if (window.recurly) {
          resolve(true);
        } else {
          reject(new Error("Error loading Recurly lib."));
        }
      };
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  log.debug(`Script has already loaded.`);

  return Promise.resolve(true);
};

const loadCSSLib = () => {
  if (typeof window === "undefined") {
    return Promise.reject();
  }

  const linkHref = "https://js.recurly.com/v4/recurly.css";

  if (!window.document.querySelector(`link[href="${linkHref}"]`)) {
    return new Promise((resolve, reject) => {
      log.debug(`Injecting stylesheet.`);

      const link = document.createElement("link");
      link.href = linkHref;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.onload = () => resolve(true);
      link.onerror = reject;
      document.body.appendChild(link);
    });
  }

  log.debug(`Stylesheet has already loaded.`);

  return Promise.resolve(true);
};

export const loadRecurlyLib = async (loadCss = true): Promise<boolean> => {
  if (typeof window === "undefined") {
    return Promise.reject();
  }

  await Promise.all([loadJSLib(), ...(loadCss ? [loadCSSLib()] : [])]);

  return true;
};

export const recurlyLoader = async () => {
  try {
    return await loadRecurlyLib();
  } catch (e) {
    log.error(e);
    return false;
  }
};
